var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    staticClass: "nav-link d-flex align-items-center justify-content-between",
    class: {
      'locked-item': _vm.disabled,
      active: _vm.isCurrentRoute,
      'router-link-active': _vm.isCurrentRoute
    },
    attrs: {
      "href": _vm.$router.resolve(_vm.routerTo).href,
      "aria-label": _vm.title,
      "aria-current": _vm.isCurrentRoute ? 'page' : null,
      "aria-disabled": _vm.disabled ? 'true' : null,
      "tabindex": _vm.disabled ? -1 : 0
    },
    on: {
      "click": function ($event) {
        $event.preventDefault();
        return _vm.onLinkClick.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('span', {
    staticClass: "menu-icon"
  }, [_c('svg-icon', {
    class: _vm.iconClass,
    attrs: {
      "name": _vm.icon,
      "viewBox": _vm.viewBox,
      "size": "20",
      "aria-hidden": "true"
    }
  })], 1), _c('div', {
    staticClass: "menu-title-container"
  }, [_c('span', {
    staticClass: "menu-title"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm.disabled ? _c('svg-icon', {
    staticClass: "static-on-hover locked-icon",
    attrs: {
      "name": "lock",
      "size": "20",
      "viewBox": "0 0 24 24"
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };